import React, { useEffect, useState } from 'react';
import { Template1 } from './InternalsNewsTemplates';
import Button from 'components/Button';
import { ExternalNews } from 'models/ExternalNews';
import ScreenOrientation from 'enum/ScreenOrientation';

type Props = {
  isOpen?: boolean;
  onClose?: () => void;
  onEnded?: () => void;
  news: ExternalNews;
  className?: string;
  duration?: number;
  screenOrientation?: ScreenOrientation;
};

const ExternalNewsPreview = ({
  isOpen,
  onClose,
  onEnded,
  news,
  className,
  screenOrientation
}: Props) => {
  const [currentItem, setCurrentItem] = useState(0);

  const second = 1000;

  const currentNews = news.content?.[currentItem];
  const quantityItems =
    news.quantityItems <= news.content.length
      ? news.quantityItems
      : news.content.length;

  useEffect(() => {
    if (currentNews) {
      const timeout = setTimeout(() => {
        setCurrentItem((prev) => (prev + 1) % quantityItems);
      }, news.duration * second);
      return () => clearTimeout(timeout);
    }
  }, [currentNews, news, quantityItems]);

  useEffect(() => {
    if (isOpen && onEnded) {
      const timeout = setTimeout(() => {
        onEnded();
      }, news.duration * second * quantityItems);

      return () => clearTimeout(timeout);
    }
  }, [isOpen, onEnded, news, quantityItems]);

  if (!isOpen || !currentNews) {
    return null;
  }

  return (
    <div className="fullscreen-container">
      <Button
        className="close-button bg-transparent border-0"
        type="button"
        icon="x-circle-fill"
        onClick={onClose}
      />
      <Template1
        title={currentNews.title}
        description={currentNews.description}
        logo={news.category.channel.logo}
        bgImage={currentNews.image}
        color={news.color}
        qrCode={currentNews.link}
        className={className}
        screenOrientation={screenOrientation}
      />
    </div>
  );
};
export default ExternalNewsPreview;
